"use strict";

var _emotion = require("emotion");

exports.onClientEntry = function () {
  if (typeof window !== "undefined" && typeof window.__EMOTION_CRITICAL_CSS_IDS__ !== "undefined") {
    (0, _emotion.hydrate)(window.__EMOTION_CRITICAL_CSS_IDS__);
  }
}; /* globals window */


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-plugin-emotion/gatsby-browser.js
// module id = 2643
// module chunks = 231608221292675